import { useEffect, useState } from 'react';

const useSigningConfirmation = (enable: boolean, showPaymentFlow: boolean, cancelPayment: () => void) => {
    const [showConfirmation, setShowConfirmation] = useState(false);

    useEffect(() => {
        if (enable) {
            setShowConfirmation(showPaymentFlow);
        }
    }, [showPaymentFlow, enable]);

    return { showConfirmation, confirm: () => setShowConfirmation(false), cancel: cancelPayment };
};

export default useSigningConfirmation;
